<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { getMessageWindowCountdown } from './helpers/messageWindowCountdown';

const props = defineProps({
  expiresAt: {
    type: Number,
    required: true,
  },
});

const currentTime = ref(Date.now());
let timerId;

const countdown = computed(() =>
  getMessageWindowCountdown(props.expiresAt, currentTime.value)
);

const statusClass = computed(() => {
  if (countdown.value.status === 'closed') {
    return 'bg-n-ruby-3 text-n-ruby-11';
  }
  if (countdown.value.status === 'urgent') {
    return 'bg-n-amber-3 text-n-amber-11';
  }
  return 'bg-n-teal-3 text-n-teal-11';
});

onMounted(() => {
  timerId = window.setInterval(() => {
    currentTime.value = Date.now();
  }, 60 * 1000);
});

onUnmounted(() => window.clearInterval(timerId));
</script>

<template>
  <span
    class="inline-flex items-center gap-0.5 px-1 py-0.5 text-[10px] font-medium leading-none rounded"
    :class="statusClass"
    :data-status="countdown.status"
  >
    <FluentIcon icon="clock" size="12" />
    <template v-if="countdown.status === 'closed'">
      {{ $t('CONVERSATION.MESSAGE_WINDOW.CLOSED') }}
    </template>
    <template v-else>
      {{
        $t('CONVERSATION.MESSAGE_WINDOW.REMAINING', {
          time: countdown.label,
        })
      }}
    </template>
  </span>
</template>
